const CHIP_STYLES = {
	editChip: {
		color: '#FFFFFF',
		background: 'rgba(255, 255, 255, 0.2)',
		border: '1px solid rgba(255, 255, 255, 0.1)',
		borderRadius: '21px',
		fontSize: '13px',
		padding: '0px 4px',
		height: '26px',
		letterSpacing: '0.15px',
		fontWeight: 500,
	},
	amendedChip: {
		color: 'rgba(231, 208, 0, 0.87);',
		background: 'rgba(231, 208, 0, 0.2)',
		border: '1px solid rgba(211, 189, 4, 0.2)',
		borderRadius: '21px',
		fontSize: '13px',
		padding: '0px 4px',
		height: '26px',
		letterSpacing: '0.15px',
		fontWeight: 500,
	},
	signchip: {
		color: '#42A5F5',
		background: 'rgba(66, 165, 245, 0.2)',
		border: '1px solid rgba(66, 165, 245, 0.1)',
		borderRadius: '21px',
		fontSize: '13px',
		padding: '0px 4px',
		height: '26px',
		letterSpacing: '0.15px',
		fontWeight: 500,
	},
};

const VERSION_HISTORY_TYPE_DESCRIPTION = {
	Edited: {
		text: 'edited the file.',
		chipProps: {
			sx: CHIP_STYLES.editChip,
			label: 'EDIT',
			color: 'primary',
			variant: 'outlined',
		},
	},
	Amended: {
		text: 'amended the file.',
		chipProps: {
			sx: CHIP_STYLES.amendedChip,
			label: 'AMENDED',
			color: 'primary',
			variant: 'outlined',
		},
	},
	Signed: {
		text: 'signed the file.',
		chipProps: {
			sx: CHIP_STYLES.signchip,
			label: 'SIGN',
			color: 'primary',
			variant: 'outlined',
		},
	},
	'Amended&Signed': {
		text: 'amended and signed the file.',
		chipProps: {
			sx: CHIP_STYLES.signchip,
			label: 'AMENDED & SIGN',
			color: 'primary',
			variant: 'outlined',
		},
	},
	Print: {
		text: 'printed the file.',
		chipProps: {
			sx: CHIP_STYLES.editChip,
			label: 'PRINT',
			color: 'primary',
			variant: 'outlined',
		},
	},
	PeerReview: {
		text: 'peer reviewed the file.',
		chipProps: {
			sx: CHIP_STYLES.editChip,
			label: 'PEER REVIEWED',
			color: 'primary',
			variant: 'outlined',
		},
	},
	CriticalFinding: {
		text: 'marked the file as critical.', // 2543 - expectation updates
		chipProps: {
			sx: CHIP_STYLES.editChip,
			label: 'CRITICAL FINDING',
			color: 'primary',
			variant: 'outlined',
		},
	},
	CriticalFindingRemoved: {
		text: 'removed critical findings from the file.', // 2544 - expectation updates
		chipProps: {
			sx: CHIP_STYLES.editChip,
			label: 'CRITICAL FINDING REMOVED',
			color: 'primary',
			variant: 'outlined',
		},
	},
};

const PEER_REVIEW_CARDS = [
	{
		score: '1',
		description: 'Concur with interpretation.',
		selected: false,
	},
	{
		score: '2a',
		description:
			'Discrepancy in interpretation/not ordinarily expected to be made (understandable miss): Unlikely to be clinically significant',
		selected: false,
	},
	{
		score: '2b',
		description:
			'Discrepancy in interpretation/not ordinarily expected to be made (understandable miss): Likely to be clinically significant',
		selected: false,
	},
	{
		score: '3a',
		description:
			'Discrepancy in interpretation/should be made most of the time: Unlikely to be clinically significant',
		selected: false,
	},
	{
		score: '3b',
		description:
			'Discrepancy in interpretation/should be made most of the time: Likely to be clinically significant',
		selected: false,
	},
];

const EXCLUDE_BOOKMARK_FORM = [
	'confidentiality',
	'orderID',
	'subject',
	'conditions',
	'allergies',
	'patientContactMethod',
	'examDuration',
	'examRoom',
	'diagnosis',
	'transport',
	'reportingDetail',
	'scheduledResource',
	'specialArrangement',
	'history',
	'signature',
	'AmendmentSignature',
	'QRcode',
	'BlumeQRcode',
	'initCursorPos',
	'patientIdBarcode',
	'studyShareURL',
	'keyImages',
];

const BOOKMARK_OPTIONS = [
	{
		id: '1',
		code: 'patientName',
		display: 'Patient Name',
		section: 'category',
	},
	{
		id: '2',
		code: 'cellPhone',
		display: 'Phone Number',
		section: 'category',
	},
	{
		id: '3',
		code: 'accessionNumber',
		display: 'Accession #',
		section: 'category',
	},
	{
		id: '4',
		code: 'birthDate',
		display: 'Date of Birth',
		section: 'category',
	},
	{
		id: '5',
		code: 'confidentiality',
		display: 'Confidentiality',
		section: 'category',
	},
	{
		id: '6',
		code: 'managingOrganization',
		display: 'Managing Organization',
		section: 'category',
	},
	{
		id: '7',
		code: 'studyID',
		display: 'Study ID',
		section: 'category',
	},
	{
		id: '8',
		code: 'orderID',
		display: 'Order ID',
		section: 'category',
	},
	{
		id: '9',
		code: 'patientID',
		display: 'Patient ID',
		section: 'category',
	},
	{
		id: '10',
		code: 'signature',
		display: 'Signature',
		section: 'category',
	},
	{
		id: '11',
		code: 'gender',
		display: 'Gender',
		section: 'category',
	},
	{
		id: '12',
		code: 'patientEmail',
		display: 'Patient Email',
		section: 'category',
	},
	{
		id: '13',
		code: 'AmendmentSignature',
		display: 'Amendment Signature',
		section: 'category',
	},
	{
		id: '14',
		code: 'subject',
		display: 'Subject',
		section: 'category',
	},
	{
		id: '15',
		code: 'dateTimeOrdered',
		display: 'Order Date/Time',
		section: 'category',
	},
	{
		id: '16',
		code: 'dateTimeAddendum',
		display: 'Date/Time Addendum',
		section: 'category',
	},
	{
		id: '17',
		code: 'dateTimeReceived',
		display: 'Date/Time Received',
		section: 'category',
	},
	{
		id: '18',
		code: 'dateTimeSigned',
		display: 'Date/Time Signed',
		section: 'category',
	},
	{
		id: '19',
		code: 'dateTimeRead',
		display: 'Date/Time Read',
		section: 'category',
	},
	{
		id: '20',
		code: 'dateTimeVerified',
		display: 'Date/Time Verified',
		section: 'category',
	},
	{
		id: '21',
		code: 'dateTimeTranscribed',
		display: 'Date/Time Transcribed',
		section: 'category',
	},
	{
		id: '22',
		code: 'department',
		display: 'Department',
		section: 'category',
	},
	{
		id: '23',
		code: 'homePhone',
		display: 'Home Phone',
		section: 'category',
	},
	{
		id: '24',
		code: 'studyDescription',
		display: 'Study Description',
		section: 'category',
	},
	{
		id: '25',
		code: 'studyStatus',
		display: 'Study Status',
		section: 'category',
	},
	{
		id: '26',
		code: 'performingPhysician',
		display: 'Performing Physician',
		section: 'category',
	},
	{
		id: '27',
		code: 'performingTechnologist',
		display: 'Performing Technologist',
		section: 'category',
	},
	{
		id: '28',
		code: 'procedureCode',
		display: 'Procedure Code',
		section: 'category',
	},
	{
		id: '29',
		code: 'patientLocation',
		display: 'Patient Location',
		section: 'category',
	},
	{
		id: '30',
		code: 'modality',
		display: 'Modality',
		section: 'category',
	},
	{
		id: '31',
		code: 'conditions',
		display: 'Conditions',
		section: 'category',
	},
	{
		id: '32',
		code: 'patientAge',
		display: 'Age at Study',
		section: 'category',
	},
	{
		id: '39',
		code: 'orderStatus',
		display: 'Order Status',
		section: 'category',
	},
	{
		id: '40',
		code: 'allergies',
		display: 'Allergies',
		section: 'category',
	},
	{
		id: '41',
		code: 'authorizationPeriod',
		display: 'Authorization Period',
		section: 'category',
	},
	{
		id: '42',
		code: 'cancellationReason',
		display: 'Cancellation Reason',
		section: 'category',
	},
	{
		id: '43',
		code: 'smokingStatus',
		display: 'Smoking Status',
		section: 'category',
	},
	{
		id: '44',
		code: 'languages',
		display: 'Languages',
		section: 'category',
	},
	{
		id: '45',
		code: 'race',
		display: 'Race',
		section: 'category',
	},
	{
		id: '46',
		code: 'ethnicity',
		display: 'Ethnicity',
		section: 'category',
	},
	{
		id: '47',
		code: 'patientContactMethod',
		display: 'Patient Contact Method',
		section: 'category',
	},
	{
		id: '48',
		code: 'examDuration',
		display: 'Exam Duration',
		section: 'category',
	},
	{
		id: '49',
		code: 'visitClass',
		display: 'Visit Class',
		section: 'category',
	},
	{
		id: '50',
		code: 'communicationStatusName',
		display: 'Communication Status Name',
		section: 'category',
	},
	{
		id: '51',
		code: 'fillerOrderNumber',
		display: 'Filler Order #',
		section: 'category',
	},
	{
		id: '52',
		code: 'insuranceCopay',
		display: 'Insurance Copay',
		section: 'category',
	},
	{
		id: '53',
		code: 'insuranceExpiry',
		display: 'Insurance Expiry',
		section: 'category',
	},
	{
		id: '54',
		code: 'insurancePayer',
		display: 'Insurance Payer',
		section: 'category',
	},
	{
		id: '55',
		code: 'insuranceStatus',
		display: 'Insurance Status',
		section: 'category',
	},
	{
		id: '56',
		code: 'examRoom',
		display: 'Exam Room',
		section: 'category',
	},
	{
		id: '57',
		code: 'reasonForExam',
		display: 'Reason For Exam',
		section: 'category',
	},
	{
		id: '58',
		code: 'healthcareService',
		display: 'Healthcare Service',
		section: 'category',
	},
	{
		id: '59',
		code: 'financialClass',
		display: 'Financial Class',
		section: 'category',
	},
	{
		id: '60',
		code: 'placerOrderNumber',
		display: 'Placer Order #',
		section: 'category',
	},
	{
		id: '61',
		code: 'patientBalance',
		display: 'Patient Balance',
		section: 'category',
	},
	{
		id: '62',
		code: 'studyUID',
		display: 'Study UID',
		section: 'category',
	},
	{
		id: '63',
		code: 'timeZone',
		display: 'Time Zone',
		section: 'category',
	},
	{
		id: '64',
		code: 'timeAtStatus',
		display: 'Time At Status',
		section: 'category',
	},
	{
		id: '65',
		code: 'lastUpdated',
		display: 'Date/Time Last Updated',
		section: 'category',
	},
	{
		id: '66',
		code: 'diagnosis',
		display: 'Diagnosis Code',
		section: 'category',
	},
	{
		id: '67',
		code: 'referringFacility',
		display: 'Referring Organization',
		section: 'category',
	},
	{
		id: '68',
		code: 'referringPhysician',
		display: 'Referring Physician',
		section: 'category',
	},
	{
		id: '69',
		code: 'readingFacility',
		display: 'Reading Organization',
		section: 'category',
	},
	{
		id: '70',
		code: 'requestedAppointmentDateTime',
		display: 'Requested Appointment Date/Time',
		section: 'category',
	},
	{
		id: '71',
		code: 'birthSex',
		display: 'Birth Sex',
		section: 'category',
	},
	{
		id: '72',
		code: 'patientAddress',
		display: 'Patient Address',
		section: 'category',
	},
	{
		id: '73',
		code: 'transcriptionist',
		display: 'Transcriptionist',
		section: 'category',
	},
	{
		id: '74',
		code: 'laterality',
		display: 'Laterality',
		section: 'category',
	},
	{
		id: '75',
		code: 'bodyPart',
		display: 'Body Part',
		section: 'category',
	},
	{
		id: '76',
		code: 'modalityModifierArray',
		display: 'Modality Modifier Array',
		section: 'category',
	},
	{
		id: '77',
		code: 'anatomicFocus',
		display: 'Anatomic Focus',
		section: 'category',
	},
	{
		id: '78',
		code: 'priority',
		display: 'Priority',
		section: 'category',
	},
	{
		id: '79',
		code: 'view',
		display: 'View',
		section: 'category',
	},
	{
		id: '80',
		code: 'techniqueObject',
		display: 'Technique Object',
		section: 'category',
	},
	{
		id: '81',
		code: 'studyDateTime',
		display: 'Study Date/Time',
		section: 'category',
	},
	{
		id: '82',
		code: 'requestedProcedureID',
		display: 'Requested Procedure ID',
		section: 'category',
	},
	{
		id: '83',
		code: 'QRcode',
		display: 'Study Share QR Code',
		section: 'category',
	},
	{
		id: '84',
		code: 'BlumeQRcode',
		display: 'Blume Registration Page QR Code',
		section: 'category',
	},
	{
		id: '85',
		code: 'authorizationNumber',
		display: 'Authorization #',
		section: 'category',
	},
	{
		id: '86',
		code: 'assigningAuthority',
		display: 'Assigning Authority',
		section: 'category',
	},
	{
		id: '87',
		code: 'accountNumber',
		display: 'Account #',
		section: 'category',
	},
	{
		id: '88',
		code: 'accountStatus',
		display: 'Account Status',
		section: 'category',
	},
	{
		id: '89',
		code: 'availability',
		display: 'Availability',
		section: 'category',
	},
	{
		id: '90',
		code: 'cdsId',
		display: 'CDS ID',
		section: 'category',
	},
	{
		id: '91',
		code: 'sourceDeviceAETitle',
		display: 'Source Device AETitle',
		section: 'category',
	},
	{
		id: '92',
		code: 'readingPhysician',
		display: 'Reading Physician',
		section: 'category',
	},
	{
		id: '93',
		code: 'transport',
		display: 'Transport',
		section: 'category',
	},
	{
		id: '94',
		code: 'orderCustomMemo',
		display: 'Order Custom Memo',
		section: 'category',
	},
	{
		id: '95',
		code: 'eligibility',
		display: 'Eligibility',
		section: 'category',
	},
	{
		id: '96',
		code: 'numImages',
		display: '# of Images',
		section: 'category',
	},
	{
		id: '97',
		code: 'reportingDetail',
		display: 'Reporting Detail',
		section: 'category',
	},
	{
		id: '98',
		code: 'imagingOrganization',
		display: 'Imaging Organization',
		section: 'category',
	},
	{
		id: '99',
		code: 'orderOfAppropriateness',
		display: 'Order Of Appropriateness',
		section: 'category',
	},
	{
		id: '100',
		code: 'pharmaceutical',
		display: 'Pharmaceutical',
		section: 'category',
	},
	{
		id: '101',
		code: 'performingPhysicianNPI',
		display: 'Performing Physician NPI',
		section: 'category',
	},
	{
		id: '102',
		code: 'readingPhysicianNPI',
		display: 'Reading Physician NPI',
		section: 'category',
	},
	{
		id: '103',
		code: 'referringPhysicianNPI',
		display: 'Referring Physician NPI',
		section: 'category',
	},
	{
		id: '104',
		code: 'scheduledResource',
		display: 'Scheduled Resource',
		section: 'category',
	},
	{
		id: '105',
		code: 'seriesUID',
		display: 'Series UID',
		section: 'category',
	},
	{
		id: '106',
		code: 'specialArrangement',
		display: 'Special Arrangement',
		section: 'category',
	},
	{
		id: '107',
		code: 'visitNumber',
		display: 'Visit #',
		section: 'category',
	},
	{
		id: '108',
		code: 'orderNotes',
		display: 'Order Notes',
		section: 'category',
	},
	{
		id: '109',
		code: 'clinicalNotes',
		display: 'Clinical Notes',
		section: 'category',
	},
	{
		id: '110',
		code: 'history',
		display: 'History',
		section: 'category',
	},
	{
		id: '111',
		code: 'transcriptionistFacility',
		display: 'Transcriptionist Organization',
		section: 'category',
	},
	{
		id: '112',
		code: 'state',
		display: 'Patient State/Province',
		section: 'category',
	},
	{
		id: '113',
		code: 'studyCustomMemo',
		display: 'Study Custom Memo',
		section: 'category',
	},
	{
		id: '114',
		code: 'sopInstanceUID',
		display: 'SOP Instance UID',
		section: 'category',
	},
	{
		id: '115',
		code: 'initCursorPos',
		display: 'Initial Cursor Position',
		section: 'category',
	},
	{
		id: '116',
		code: 'keyImages',
		display: 'Key Images',
		section: 'category',
	},
	{
		id: '117',
		code: 'patientIdBarcode',
		display: 'Patient ID Barcode',
		section: 'category',
	},
	{
		id: '118',
		code: 'consultingPhysician',
		display: 'Consulting Physician',
		section: 'category',
	},
	{
		id: '119',
		code: 'referringPhysicianFaxNumber',
		display: 'Referring Physician Fax Number',
		section: 'category',
	},
	{
		id: '120',
		code: 'studyShareURL',
		display: 'Study Share URL',
		section: 'category',
	},
	{
		id: '121',
		code: 'patientgiven',
		display: 'Patient First Name',
		section: 'category',
	},
	{
		id: '122',
		code: 'patientfamily',
		display: 'Patient Last Name',
		section: 'category',
	},
	{
		id: '123',
		code: 'patientsAge',
		display: 'Patient Age',
		section: 'category',
	},
];

const BLANK_FIELD = {
	code: 'Custom Field',
	display: 'Custom Field',
	isBlank: true,
	section: 'field',
};

export { VERSION_HISTORY_TYPE_DESCRIPTION, PEER_REVIEW_CARDS, BOOKMARK_OPTIONS, BLANK_FIELD, EXCLUDE_BOOKMARK_FORM };
